export default {
    cash: 'Comptant',
    financed: 'Financé',
};
